import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getUsers } from './actions'
import { applySpec, prop, pipe } from 'ramda'

export const withUsers = WrappedComponent => {
  class WithUsers extends Component {
    componentDidMount () {
      this.props.getUsers()
    }

    render () {
      return <WrappedComponent users={this.props.users} {...this.props} />
    }
  }

  WithUsers.propTypes = {
    getUsers: PropTypes.func.isRequired,
    users: PropTypes.array.isRequired
  }

  return WithUsers
}

export default pipe(
  withUsers,
  connect(
    applySpec({
      users: prop('users')
    }),
    {
      getUsers
    }
  )
)



// WEBPACK FOOTER //
// ./src/components/with-users/container/index.js